import React, { useState } from 'react';

function Onboarding({ onDone }) {
  const [step, setStep] = useState(0);

  const steps = [
    {
      icon: '🏦',
      title: 'Подключите банк',
      text: 'Подключите Сбер или Точку, чтобы Khepri видел реальные поступления и списания. Это можно сделать в разделе «Банки».',
    },
    {
      icon: '📊',
      title: 'Проверьте прогноз',
      text: 'Khepri предскажет кассовые разрывы на 14 дней вперёд и предупредит о рисках. Всё это — на главном экране.',
    },
    {
      icon: '📅',
      title: 'Следите за налогами',
      text: 'Налоговый календарь напомнит о платежах, а ИИ найдёт льготы для вашего бизнеса. Всё это — в разделе «Налоги».',
    },
  ];

  return (
    <div style={{ textAlign: 'center', padding: 40, background: '#1E293B', borderRadius: 12, maxWidth: 500, margin: '40px auto', border: '1px solid #334155' }}>
      <div style={{ fontSize: 48, marginBottom: 16 }}>{steps[step].icon}</div>
      <h2 style={{ marginBottom: 8 }}>{steps[step].title}</h2>
      <p style={{ color: '#94A3B8', marginTop: 12, marginBottom: 24, fontSize: 15, lineHeight: 1.6 }}>
        {steps[step].text}
      </p>

      <div style={{ display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap' }}>
        {step > 0 && (
          <button onClick={() => setStep(step - 1)} style={{ padding: '10px 24px', background: '#334155', color: '#F8FAFC', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}>
            Назад
          </button>
        )}
        {step < 2 ? (
          <button onClick={() => setStep(step + 1)} style={{ padding: '10px 24px', background: '#6366F1', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}>
            Далее
          </button>
        ) : (
          <button onClick={onDone} style={{ padding: '10px 24px', background: '#10B981', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}>
            Начать работу
          </button>
        )}
      </div>

      <div style={{ marginTop: 16, display: 'flex', gap: 6, justifyContent: 'center' }}>
        {steps.map((_, i) => (
          <div key={i} style={{ width: i === step ? 24 : 8, height: 8, borderRadius: 4, background: i === step ? '#6366F1' : '#334155', transition: 'all 0.3s' }} />
        ))}
      </div>

      <div style={{ marginTop: 20, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{ color: '#94A3B8', fontSize: 13 }}>Шаг {step + 1} из 3</span>
        <button onClick={onDone} style={{ background: 'none', border: 'none', color: '#94A3B8', cursor: 'pointer', fontSize: 13, textDecoration: 'underline' }}>
          Пропустить
        </button>
      </div>
    </div>
  );
}

export default Onboarding;